import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const EyeIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\uE8F4'}</MuiIcon>
        );
    })
